// Core map types
export type Position = {
  lat: number;
  lng: number;
};

export type MapType = 'roadmap' | 'satellite' | 'terrain' | 'hybrid';

export interface MapConfig {
  center: Position;
  zoom: number;
  mapType: MapType;
  gestureHandling: 'greedy' | 'cooperative' | 'auto' | 'none';
  disableDefaultUI: boolean;
}

// Marker types
export const MARKER_TYPES = {
  JOBSITE: 'Jobsite',
  YARDS: 'Yards',
  EQUIPMENTS: 'Equipments',
  EMPLOYEES: 'Employees'
} as const;

export type MarkerType = (typeof MARKER_TYPES)[keyof typeof MARKER_TYPES];

export interface MapFilters {
  [MARKER_TYPES.JOBSITE]: boolean;
  [MARKER_TYPES.YARDS]: boolean;
  [MARKER_TYPES.EQUIPMENTS]: boolean;
  [MARKER_TYPES.EMPLOYEES]: boolean;
}

export const INITIAL_FILTERS: MapFilters = {
  [MARKER_TYPES.JOBSITE]: true,
  [MARKER_TYPES.YARDS]: true,
  [MARKER_TYPES.EQUIPMENTS]: true,
  [MARKER_TYPES.EMPLOYEES]: true
};

// Marker interfaces
export interface Marker {
  id: number | string;
  position: Position;
  title?: string;
  type: MarkerType;
  label?: string;
  draggable?: boolean;
  zIndex?: number;
  children?: React.ReactNode;
  onClick?: (e: google.maps.MapMouseEvent) => void;
  details?: {
    // Jobsite details
    customerName?: string;
    locationAddress?: string;
    jobsiteType?: string;
    jobsToday?: string;

    // Yard details
    statusAvailability?: string;
    associatedEquipmentCount?: string;

    // Equipment details
    status?: string;
    make?: string;
    model?: string;
    assignedJob?: string;
    currentOperator?: string;

    // Employee details
    jobRole?: string;
    currentLocation?: string;
    phone?: string;
    email?: string;
    assignedTruck?: string;
    direction?: number | null;
    speed?: number;
    deviceBatteryLevel?: number;
    date?: string;

    // Common GPS properties
    online?: boolean;
    moving?: boolean;
  };
}

export interface MarkerStyle {
  backgroundColor: string;
  color: string;
  border: string;
}

export interface IconProps {
  fontSize?: number;
  color?: string;
}

// Address types for JobSiteCreation
export type PlaceDetails = {
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
};

export type HighlightedFields = {
  address?: boolean;
  city?: boolean;
  state?: boolean;
  zipCode?: boolean;
  country?: boolean;
  latitude?: boolean;
  longitude?: boolean;
};
